import React from 'react';
import { Stock } from '../../types';

import { Button } from '../atoms/Button';

import { Card } from '../atoms/Card';

interface StockCardProps {
  stock: Stock;
  onBuy: (stock: Stock) => void;
  onSell: (stock: Stock) => void;
}

export const StockCard: React.FC<StockCardProps> = ({ stock, onBuy, onSell }) => (
  <Card className="p-4" data-testid={`stock-card-${stock.symbol}`}>
    <div className="flex justify-between items-start mb-2">
      <div>
        <h3 className="font-semibold text-gray-900 dark:text-white">{stock.symbol}</h3>
        <p className="text-sm text-gray-600 dark:text-gray-300">{stock.name}</p>
      </div>
      <div className="text-right">
        <p className="font-semibold text-gray-900 dark:text-white">${stock.price.toFixed(2)}</p>
        <p className={`text-sm ${stock.change >= 0 ? 'text-green-600' : 'text-red-600'}`}>
          {stock.change >= 0 ? '+' : ''}${stock.change.toFixed(2)} ({stock.changePercent?.toFixed(2)}%)
        </p>
      </div>
    </div>
    <div className="flex gap-2 mt-3">
      <Button size="sm" variant="success" onClick={() => onBuy(stock)} data-testid={`buy-${stock.symbol}`}>
        Buy
      </Button>
      <Button size="sm" variant="danger" onClick={() => onSell(stock)} data-testid={`sell-${stock.symbol}`}>
        Sell
      </Button>
    </div>
  </Card>
);